export var CustomFieldType;
(function (CustomFieldType) {
    CustomFieldType[CustomFieldType["Undefined"] = 0] = "Undefined";
    CustomFieldType[CustomFieldType["Text"] = 1] = "Text";
    CustomFieldType[CustomFieldType["LongText"] = 2] = "LongText";
    CustomFieldType[CustomFieldType["Number"] = 3] = "Number";
    CustomFieldType[CustomFieldType["Checkbox"] = 4] = "Checkbox";
    CustomFieldType[CustomFieldType["Radio"] = 5] = "Radio";
    CustomFieldType[CustomFieldType["List"] = 6] = "List";
    CustomFieldType[CustomFieldType["LineBreak"] = 7] = "LineBreak";
})(CustomFieldType || (CustomFieldType = {}));
